import { Button } from 'antd';
import React, { useContext } from 'react';
import { RowContext } from './DragRow';

type DragHandleProps = {
  cursor?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
};

export const DragHandle: React.FC<DragHandleProps> = props => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext);
  const { disabled } = props;

  const defaultIcon = (
    <span className={disabled ? 'cfs-table-drag_disabled' : 'cfs-table-drag'}>::</span>
  );

  return (
    <Button
      type="text"
      size="small"
      icon={props.icon || defaultIcon}
      style={{
        cursor: disabled ? 'not-allowed' : props.cursor || 'move',
        backgroundColor: 'transparent',
      }}
      ref={disabled ? undefined : setActivatorNodeRef}
      {...(disabled ? {} : listeners)}
    />
  );
};
